import {connect} from 'react-redux'
import DeliveryGroupsMap from "../../Components/Map/DeliveryGroupsMap/DeliveryGroupsMap";
import * as deliveryGroupsActions from "../actions/deliveryGroupsActions";

const mapStateToProps = (store) => {
    const props = {
        orders: {
            ...store.ordersReducer,
            deliveryOrdersWithLocation: store.ordersReducer.deliveryOrders.filter(order => order.location)
        },
        business: store.businessReducer,
        users: store.usersReducer,
        deliveryGroups: store.deliveryGroupsReducer,
        isMerukazotEnabled: store.businessReducer.business.isMerukazotEnabled
    };

    if (store.businessReducer.business.isMerukazotEnabled && store.businessReducer.business.merukazotMin >= 0)
        props.merukazotMin = store.businessReducer.business.merukazotMin;

    return props;
};

const mapDispatchToProps = {
    evaluateDeliveryGroups: deliveryGroupsActions.evaluateDeliveryGroupsAction,
    addOrdersToLockedGroup: deliveryGroupsActions.addOrdersToLockedGroup,
    removeOrdersFromLockedGroup: deliveryGroupsActions.removeOrdersFromLockedGroup,
    unlockDeliveryGroup: deliveryGroupsActions.unlockDeliveryGroup,
    lockDeliveryGroup: deliveryGroupsActions.lockDeliveryGroup
};

const DeliveryGroupsMapContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryGroupsMap);

export default DeliveryGroupsMapContainer;